import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';
import { isValidEmail } from '../../../helpers/form-validation';

import Button from '../../../component-library/button';
import SpinnerContainer from '../../../component-library/spinner-container';
import FormField from '../../../component-library/form-field';
import Tile from '../../../component-library/tile';

import RefDataSearchModal from './sub-components-kp/ref-data-search-modal';
import FormItem from './sub-components-kp/form-item';

const RegisterForAccessFormKp = () => {
	const { data, uiMenuConfig } = useOutletContext();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [conversationId, setConversationId] = useState('');
	const [formMetaData, setFormMetaData] = useState({});
	const [formData, setFormData] = useState([]);
	const [message, setMessage] = useState('I would like to request provider approval to get API access.');
	const [messageError, setMessageError] = useState('');
	const [disableSubmit, setDisableSubmit] = useState(false);
	const [showSuccess, setShowSuccess] = useState(false);
	const [showRefDataSearchModal, setShowRefDataSearchModal] = useState(false);
	const [hasOauth, setHasOauth] = useState(false);
	const maxCommentLength = 512;

	const handleChange = (index, value) => {
		const newFormData = [
			...formData,
		];
		newFormData[index].value = value;

		const formField = newFormData[index];

		// When selecting/deselecting subscription make sure
		// associated fields have the correct hidden value
		if (formField.id === 'subscription') {
			const field1 = newFormData.find(item => item.id === 'prodtranssec');
			const field2 = newFormData.find(item => item.id === 'prodpeaktranssec');
			const field3 = newFormData.find(item => item.id === 'prodmaxvolday');
			const field4 = newFormData.find(item => item.id === 'prodtimefram');
			const field5 = newFormData.find(item => item.id === 'prodavemsgsize');
			const field6 = newFormData.find(item => item.id === 'prodmaxmsgsize');
			const field1Index = newFormData.indexOf(field1);
			const field2Index = newFormData.indexOf(field2);
			const field3Index = newFormData.indexOf(field3);
			const field4Index = newFormData.indexOf(field4);
			const field5Index = newFormData.indexOf(field5);
			const field6Index = newFormData.indexOf(field6);

			if (value === 'true') {
				newFormData[field1Index].hidden = false;
				newFormData[field2Index].hidden = false;
				newFormData[field3Index].hidden = false;
				newFormData[field4Index].hidden = false;
				newFormData[field5Index].hidden = false;
				newFormData[field6Index].hidden = false;
			} else {
				newFormData[field1Index].hidden = true;
				newFormData[field2Index].hidden = true;
				newFormData[field3Index].hidden = true;
				newFormData[field4Index].hidden = true;
				newFormData[field5Index].hidden = true;
				newFormData[field6Index].hidden = true;
			}
			newFormData[field1Index].value = '';
			newFormData[field2Index].value = '';
			newFormData[field3Index].value = '';
			newFormData[field4Index].value = '';
			newFormData[field5Index].value = '';
			newFormData[field6Index].value = '';
		}

		// When selecting/deselecting newClientId make sure
		// associated fields have the correct required value
		if (formField.id === 'newClientId') {
			const field1 = newFormData.find(item => item.id === 'clientIdEnvironment');
			const field2 = newFormData.find(item => item.id === 'grantType');
			const field3 = newFormData.find(item => item.id === 'consumerAtlasTechLeadEmail');
			const field1Index = newFormData.indexOf(field1);
			const field2Index = newFormData.indexOf(field2);
			const field3Index = newFormData.indexOf(field3);

			if (value === true) {
				newFormData[field1Index].required = true;
				newFormData[field2Index].required = true;
				newFormData[field3Index].required = true;
			} else {
				newFormData[field1Index].required = false;
				newFormData[field2Index].required = false;
				newFormData[field3Index].required = false;
			}
		}

		setFormData(newFormData);
	};

	const handleMultiSelectChange = (index, value) => {
		const newArray = Array.from(value, newItem => newItem.value);
		const newFormData = [
			...formData,
		];
		newFormData[index].value = newArray;
		setFormData(newFormData);
	};

	const checkAtlasDesignIdStatus = () => {
		// Check required/disabled status of fields depending on state of atlasDesignId
		const newFormData = [
			...formData,
		];

		const atlasDesignId = newFormData.find(item => item.id === 'atlasDesignId');

		const field1 = newFormData.find(item => item.id === 'appComponent');
		const field2 = newFormData.find(item => item.id === 'desc');
		const field3 = newFormData.find(item => item.id === 'organization');
		const field4 = newFormData.find(item => item.id === 'market');
		const field5 = newFormData.find(item => item.id === 'consumerhostloc');
		const field6 = newFormData.find(item => item.id === 'cloudloc');
		const field7 = newFormData.find(item => item.id === 'atlasDesignId');
		const field8 = newFormData.find(item => item.id === 'atlasDesignName');
		const field1Index = newFormData.indexOf(field1);
		const field2Index = newFormData.indexOf(field2);
		const field3Index = newFormData.indexOf(field3);
		const field4Index = newFormData.indexOf(field4);
		const field5Index = newFormData.indexOf(field5);
		const field6Index = newFormData.indexOf(field6);
		const field7Index = newFormData.indexOf(field7);
		const field8Index = newFormData.indexOf(field8);

		if (atlasDesignId.value) {
			newFormData[field2Index].required = false;
			newFormData[field3Index].required = false;
			newFormData[field4Index].required = false;
			newFormData[field5Index].required = false;
			newFormData[field6Index].required = false;
			newFormData[field1Index].hidden = true;
			newFormData[field2Index].hidden = true;
			newFormData[field3Index].hidden = true;
			newFormData[field4Index].hidden = true;
			newFormData[field5Index].hidden = true;
			newFormData[field6Index].hidden = true;
			newFormData[field1Index].value = '';
			newFormData[field2Index].value = '';
			newFormData[field3Index].value = '';
			newFormData[field4Index].value = [];
			newFormData[field5Index].value = '';
			newFormData[field6Index].value = '';
			newFormData[field7Index].hidden = false;
			newFormData[field8Index].hidden = false;
		} else {
			newFormData[field2Index].required = true;
			newFormData[field3Index].required = true;
			newFormData[field4Index].required = true;
			newFormData[field5Index].required = true;
			newFormData[field6Index].required = true;
			newFormData[field1Index].hidden = false;
			newFormData[field2Index].hidden = false;
			newFormData[field3Index].hidden = false;
			newFormData[field4Index].hidden = false;
			newFormData[field5Index].hidden = false;
			newFormData[field6Index].hidden = false;
			newFormData[field7Index].hidden = true;
			newFormData[field8Index].hidden = true;
			newFormData[field7Index].value = '';
			newFormData[field8Index].value = '';
		}

		setFormData(newFormData);
	};

	const handleRefDataClick = item => {
		const matchArray = formMetaData?.refDataMatching || [];
		const newFormData = [
			...formData,
		];

		if (matchArray?.length) {
			matchArray.forEach(entry => {
				const formDataItem = formData.find(i => i.id === entry.formFieldId);
				const formDataIndex = formData.indexOf(formDataItem);

				newFormData[formDataIndex].value = item[entry.refDataField];
			});
		}

		setShowRefDataSearchModal(false);
		setFormData(newFormData);
		checkAtlasDesignIdStatus();
	};

	const handleMessageChange = value => {
		setMessage(value);
	};

	const getConversationId = () => {
		fetchData({
			uri: `/api/web/asks/catitem/${data.id}?pageSize=0`,
			method: 'GET',
		})
			.then(res => {
				const newConversationId = res.body.conversations[0].conversation.key;
				setConversationId(newConversationId);
			});
	};

	const handleSubmit = () => {
		const newItems = [];
		formData.forEach(item => {
			if (item.type !== 'subheading') {
				const newItem = {
					label: item.label,
					value: item.value,
					id: item.id,
				};
				newItems.push(newItem);
			}
		});
		const commentData = {
			message,
			styling: 'request',
			template: 'default',
			templatedData: {
				items: newItems,
			},
		};

		fetchData({
			uri: `/api/web/asks/catitem/${data.id}/conv/${conversationId}`,
			method: 'POST',
			options: {
				body: JSON.stringify(commentData),
			},
		})
			.then(({ ok }) => {
				if (ok) {
					setShowSuccess(true);
					setDisableSubmit(false);
				} else {
					setError('Sorry, your request could not be sent at this time, please try again.');
					setDisableSubmit(false);
				}
			})
			.catch(() => {
				setError('Sorry, your request could not be sent at this time, please try again.');
				setDisableSubmit(false);
			});
	};

	const handleValidation = isDuplicate => {
		let newError = false;
		const newFormData = [];
		if (message === '') {
			newError = true;
			setMessageError('You must add a message.');
		}
		if (message.length > maxCommentLength) {
			newError = true;
			setMessageError(`Message must be less than ${maxCommentLength} characters in length.`);
		}
		formData.forEach(item => {
			if (item.required === true && item.type !== 'email' && item.value?.length === 0) {
				newError = true;
				const newItem = {
					...item,
					error: 'This is a required field.',
				};
				newFormData.push(newItem);
			} else if (item.required === true && item.type === 'email') {
				if (!isValidEmail(item.value)) {
					newError = true;
					const newItem = {
						...item,
						error: 'Must be a valid email address.',
					};
					newFormData.push(newItem);
				} else {
					const newItem = {
						...item,
						error: '',
					};
					newFormData.push(newItem);
				}
			} else {
				const newItem = {
					...item,
					error: '',
				};
				newFormData.push(newItem);
			}
		});

		// Validate duplicate design name
		const newAppComponent = newFormData.find(item => item.id === 'appComponent');
		const newAppComponentIndex = newFormData.indexOf(newAppComponent);
		if (isDuplicate) {
			newError = true;
			newFormData[newAppComponentIndex].error = 'This value will result in a duplicate being created, please select a unique value.';
		} else {
			newFormData[newAppComponentIndex].error = '';
		}

		if (newError === true) {
			setFormData(newFormData);
			setDisableSubmit(false);
		} else {
			setFormData(newFormData);
			handleSubmit();
		}
	};

	const checkDuplicateDesign = () => {
		setDisableSubmit(true);

		const newFormData = [
			...formData,
		];

		const atlasDesignId = newFormData.find(item => item.id === 'atlasDesignId');

		// Only check for a duplicate design if no atlasDesignId
		if (atlasDesignId.value) {
			handleValidation(false);
		} else {
			let newDesignName = '';

			const newAtlasName = newFormData.find(item => item.id === 'atlasName').value;
			const newAppComponent = newFormData.find(item => item.id === 'appComponent').value;

			if (newAppComponent) {
				newDesignName = `${newAtlasName} ${newAppComponent}`;
			} else {
				newDesignName = newAtlasName;
			}

			newDesignName = encodeURIComponent(newDesignName);

			fetchData({
				uri: `/api/web/ics/search/designname?text=${newDesignName}`,
				method: 'GET',
			})
				.then(({ ok, body }) => {
					if (ok) {
						if (body.results?.length > 0) {
							handleValidation(true);
						} else {
							handleValidation(false);
						}
					} else {
						handleValidation(false);
					}
				})
				.catch(() => {
					handleValidation(false);
				});
		}
	};

	const getData = () => {
		fetchData({
			uri: '/api/web/asks/template/default',
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newFormData = body.items;
					const newFormMetaData = body?.metadata || {};
					setFormMetaData(newFormMetaData);
					setFormData(newFormData);
					setLoading(false);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const getOauthData = () => {
		fetchData({
			uri: `/api/web/ics/search/secpolicy?ids=${data.id}`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const policies = body?.results[0]?.policies || [];
					if (policies.length) {
						setHasOauth(true);
					}
				}
			});
	};

	useEffect(() => {
		getData();
		getOauthData();
		getConversationId();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.registerForAccess?.label || 'Subscribe'}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{showSuccess && (
				<Tile className="margin-bottom-24">
					<p><strong>Your access request has been submitted.</strong></p>
					<p>
						Thank you for submitting your request, the provider will be in touch shortly.
						You can find updates to your request in the &rsquo;Contact Provider&rsquo; section.
					</p>
				</Tile>
			)}
			{(!loading && !showSuccess) && (
				<Tile className="margin-bottom-24">
					<p>Request provider approval to get API access.</p>
					<div className="border-bottom">
						<FormField
							label="Message"
							type="text"
							action={e => { handleMessageChange(e.target.value); }}
							id="message"
							name="message"
							value={message}
							required
							error={messageError}
							fullWidth
						/>
					</div>
					{formData?.length ? (
						<>
							<div className="get-api-access__form-row-2-col">
								{formData.map((field, index) => (
									<FormItem
										// eslint-disable-next-line react/no-array-index-key
										key={index}
										field={field}
										index={index}
										hasOauth={hasOauth}
										handleChange={(idx, value) => handleChange(idx, value)}
										handleMultiSelectChange={
											(idx, options) => handleMultiSelectChange(idx, options)
										}
										setShowRefDataSearchModal={() => setShowRefDataSearchModal(true)}
									/>
								))}
							</div>
							{error && (
								<p className="font-color-theme-danger">{error}</p>
							)}
							<div className="text-right">
								<Button
									type="primary"
									label="Submit"
									onClick={() => checkDuplicateDesign()}
									isDisabled={disableSubmit}
								/>
							</div>
						</>
					) : (
						<p className="grey-text margin-top-16">
							No form fields have been configured.
						</p>
					)}
				</Tile>
			)}
			{showRefDataSearchModal && (
				<RefDataSearchModal
					handleCloseModal={() => setShowRefDataSearchModal(false)}
					handleApplyData={item => handleRefDataClick(item)}
				/>
			)}
		</>
	);
};

export default RegisterForAccessFormKp;
